import Quimbee from 'quimbee'
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  initialize() {
    const stateLinkElements = this.element.querySelectorAll("a")
    const data = Quimbee.data.usaInteractiveMap || {}

    // for each state both href and xlink:href are set due to xlink:href is deprecated but href is not supported by Safari yet.
    stateLinkElements.forEach((linkElement) => {
      const state = data.statesData[linkElement.id]
      const stateIsHighlighted = state[data.highlightSupporting] === true

      if (state) {
        const stateAttributes = {
          "xlink:href": state["path"],
          "href": state["path"]
        }

        if (stateIsHighlighted) {
          stateAttributes["aria-label"] = `${state["name"]} is covered`
          stateAttributes["class"] = "state-link state-link-supported"
        } else {
          stateAttributes["aria-label"] = `${state["name"]} is not covered`
          stateAttributes["class"] = "state-link state-link-not-supported"
        }
        this.setAttributes(linkElement, stateAttributes)
      }
    })
  }

  setAttributes(el, attrs) {
    let key
    for(key in attrs) {
      if (Object.prototype.hasOwnProperty.call(attrs, key)) {
        el.setAttribute(key, attrs[key])
      }
    }
  }
}
